
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.68 12.65a5 5 0 1 1 5-5 5 5 0 0 1-5 5m8.9 3l-4-4A6.24 6.24 0 0 0 14 7a6.33 6.33 0 0 0-12.6.31 6 6 0 0 0 0 .85A6.36 6.36 0 0 0 7 14a6.28 6.28 0 0 0 4.69-1.36l4 4a.22.22 0 0 0 .32 0l.64-.64a.22.22 0 0 0 0-.32"}})])
          )
        }
      }
    